import React, { Component } from 'react'
// CUSTOM
import * as helpers from '../helpers/helpers'
import './Copyright.scss'
let config = window.config
// import config from './../config.json'

class Copyright extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showCopyright: true,
      copyrightPanelOpen: true,
      containerCollapsed: false,
      basemapCopyright: [],
      label: ''
    }

    // LISTEN FOR CONTROL VISIBILITY CHANGES
    window.emitter.addListener('mapControlsChanged', (control, visible) =>
      this.controlStateChange(control, visible)
    )
    window.emitter.addListener('layerMapUpdate', () => this.updateLabel())
  }

  componentDidMount() {
    helpers.waitForLoad("settings", Date.now(), 30, () => {
      if (window.config.basemapCopyright === false) return;
      this.setState({
        basemapCopyright: window.config.basemapCopyright,
        showCopyright: window.mapControls.copyright
      }, () => {
        helpers.waitForLoad('map', Date.now(), 30, () => this.onMapLoad())
      })
    });
  }

  onMapLoad() {
    this.setState({
      label: window.config.basemapCopyright.find((item) =>
        item.name.includes('ZBGIS')
      )?.source
    })
    // window.copyright = this.state.label;
    // setTimeout(() => {
    //   let selectedBasemap = document.getElementById('btnBasemapSwitcher').innerText
    //   console.log(selectedBasemap)

    //   const sourceByBasemap = this.state.basemapCopyright.find((item) =>
    //   item.name.includes(selectedBasemap)
    //   )?.source
    //   console.log(sourceByBasemap)
    //   this.setState({
    //     label: sourceByBasemap
    //   })
    // }, 6000)
  }

  updateLabel = () => {
    // Získanie viditeľných vrstiev z mapy
    const visibleLayers = window.map
      .getLayers()
      .getArray()
      .filter((layer) => layer.getVisible());

    const labels = [];

    visibleLayers.forEach((layer) => {
      const tocDisplayName = layer.get('tocDisplayName');
      const groupName = layer.get('groupName');
      const name = layer.get('name');

      // Určenie názvu vrstvy podľa priorít
      let finalName = tocDisplayName || groupName || name;
      // Kontrola autorských práv v stave
      const stateCopyright = this.state.basemapCopyright || [];
      if (!Array.isArray(stateCopyright)) {
        console.error('basemapCopyright is not an array');
        return;
      }
      let copyright = stateCopyright.find((item) =>
        item.name.includes(tocDisplayName)
      )?.source;
      
      // Ak copyright nebol nájdený, hľadáme podľa groupName
      if (!copyright && groupName) {
        copyright = stateCopyright.find((item) =>
          item.name.includes(groupName)
        )?.source;
      }
      
      // Ak copyright stále nebol nájdený, hľadáme podľa name
      if (!copyright && name) {      
        copyright = stateCopyright.find((item) =>
          item.name.includes(name)
        )?.source;
      }
      // Ak copyright stále nebol nájdený, hľadáme bez čísel
      if (!copyright) {
        const nameWithoutNumbers = finalName.replace(/\d+/g, '').trim();
        copyright = stateCopyright.find((item) =>
          item.name.includes(nameWithoutNumbers)
        )?.source;
      }
      // Pridanie copyrightu do labelov, ak existuje
      if (copyright) {
        labels.push(copyright);
      }
    });    
    // Odstránenie duplicitných labelov
    const uniqueLabels = [...new Set(labels)];
    // Aktualizácia stavu s deduplikovanými labelmi    
    this.setState({ label: uniqueLabels });
  };

  controlStateChange = (control, visible) => {
    if (control === 'copyright') {
      this.setState({ showCopyright: visible })
    }
  }

  onCollapsedClick = (evt) => {
    // HIDE OPEN PANELS
    if (this.state.containerCollapsed === false) {
      this.setState({ copyrightPanelOpen: false })
    }
    this.setState({ containerCollapsed: !this.state.containerCollapsed })
  }
  componentDidUpdate() {
    window.copyright = this.state.label
    this.props.asdf(this.state.label)
  }
  render() {
    return (
      <div className={!this.state.showCopyright ? ' sc-hidden' : ''}>
        <div id="copyright-container">
          <div
            id="copyright-collapse-button"
            className={
              this.state.containerCollapsed
                ? 'copyright-collapse-button'
                : 'copyright-collapse-button closed'
            }
            onClick={this.onCollapsedClick}
          />
          <div
            className={
              this.state.containerCollapsed ? 'copyright-hidden' : 'copyright'
            }
          >
            {Array.isArray(this.state.label)
              ? this.state.label.map((item, index) => (                
                <div key={index}>{item}</div>
              ))
              : <div>{this.state.label}</div>}              
            <span style={{fontSize:18}}><b>Obsah stránky je informatívny a nie je použiteľný na právne účely!</b></span>
          </div>
        </div>
      </div>
    )
  }
}

export default Copyright
